import useMembers from '@/hooks/useMembers';

import { SpeechProviderIcon } from './helper';
import { ResourceTile } from '../../components/ResourceList/ResourceTile';
import {
  CreatorMeta,
  LastUsedMeta,
  ResourceTileMeta,
} from '../../components/ResourceList/ResourceTileParts';
import { SpeechModel } from '../../types';

interface SpeechModelItemProps {
  speechModel: SpeechModel;
  isSelected: boolean;
  onOpen: (speechModel: SpeechModel) => void;
}

export const SpeechModelItem = ({ speechModel, isSelected, onOpen }: SpeechModelItemProps) => {
  const { getMember } = useMembers();
  const creator = speechModel.created_by ? getMember(speechModel.created_by) : undefined;

  return (
    <ResourceTile
      icon={<SpeechProviderIcon provider={speechModel.provider} className="size-6" />}
      title={speechModel.name}
      meta={
        <ResourceTileMeta>
          {creator && <CreatorMeta member={creator} />}
          <LastUsedMeta lastUsedAt={speechModel.last_used_at} />
        </ResourceTileMeta>
      }
      onOpen={() => onOpen(speechModel)}
      isSelected={isSelected}
    />
  );
};
